import { render, staticRenderFns } from "./dynastiesManage.vue?vue&type=template&id=702d6189&scoped=true&"
import script from "./dynastiesManage.vue?vue&type=script&lang=js&"
export * from "./dynastiesManage.vue?vue&type=script&lang=js&"
import style0 from "./dynastiesManage.vue?vue&type=style&index=0&id=702d6189&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702d6189",
  null
  
)

export default component.exports